import { UserAuthErrorCode } from '../types'
import { userAuthErrorClass } from './userAuthErrorClass'

/**
 * `errorClass` predicate for the login mutations (password and magic-link).
 *
 * Labels only the user-auth codes the login flows already turn into a user-facing
 * message. Anything else stays unlabelled so it still surfaces as a real error.
 */
const EXPECTED_USER_AUTH_CODES: string[] = [
    UserAuthErrorCode.INVALID_EMAIL_OR_PASSWORD,
    UserAuthErrorCode.OUTSIDE_GEOFENCE,
    UserAuthErrorCode.USER_EXCLUDED_GAMBLING_AUTHORITY,
    UserAuthErrorCode.RATE_LIMIT_EXCEEDED,
    UserAuthErrorCode.USER_MUST_REACTIVATE,
    UserAuthErrorCode.REACTIVATION_FAILED_DUE_TO_BEING_SUSPENDED,
    UserAuthErrorCode.REACTIVATION_FAILED_DUE_TO_GAMBLING_EXCLUSION,
    UserAuthErrorCode.MAGIC_LINK,
]

export const loginErrorClass = userAuthErrorClass(EXPECTED_USER_AUTH_CODES, error => error.status === 429)
